import React from "react";

import Landing from "pages/Landing";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "./App.scss";

function App() {

  return (
    <Router>
      <Switch>
        <Route path="/">
          <Landing/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
